import { HttpClient } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { MdbTableDirective } from 'mdb-angular-ui-kit/table';
import { ModalAppsComponent } from 'src/app/components/crud/modal-apps/modal-apps.component';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';
import { Apps } from 'src/app/models/interfaces.model';
import Swal from 'sweetalert2';
import { environment } from 'src/app/environments/environments';
@Component({
  selector: 'app-apps',
  templateUrl: './apps.component.html',
  styleUrls: ['./apps.component.css']
})
export class AppsComponent {
  @ViewChild('table') table!: MdbTableDirective<Apps>;

  modalRef: MdbModalRef<ModalAppsComponent> | null = null;

  loading = true;
  loadingFull = false;

  headers = [
    { label: 'Apps', field: 'NAME', disableSort: false },
    { label: 'AppLogo', field: 'APPLOGO', disableSort: false },
    { label: 'Activo', field: 'ACTIVE', disableSort: false },
  ];

  dataSource: Apps[] = [];

  constructor(private modalService: MdbModalService, private _http: HttpClient, private crudService: GenericCrudService<Apps>) {}

  async ngOnInit(): Promise<void> {
    await this.getAllApps();
  }

  search(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value;
    this.table.search(searchTerm);
  }

  async getAllApps(): Promise<void> {
    const body = new FormData();
    body.append('action', "SELECT");
    body.append('table_name', "APPS");

    return new Promise<void>((resolve, reject) => {
    this.crudService.crud(body, environment.EndPointCrud).subscribe((data: any) => {
      if (data && data.status === 1 && data.data) {
        this.dataSource = data.data.map((entry: any) => {
          return {
            ID: entry.ID,
            NAME: entry.NAME,
            APPLOGO: entry.APPLOGO,
            ACTIVE: entry.ACTIVE,
          };
        });
        this.loading = false;
        //this.loadingFull = false;
      } else {
        console.error('Error: No se pudo obtener la data de las compañías.');
      }
    }, error => {
      console.error('Error: ', error);
    });
  });
  }

  async  openModal(mode: 'add' | 'edit', data?: Apps): Promise<void> {
    this.modalRef = this.modalService.open(ModalAppsComponent, {
      data: {
        modalTitle: mode === 'edit' ? 'Editar Apps' : 'Nueva Apps',
        appsName: data ? data.NAME : '',
        appLogo: data ? data.APPLOGO : '',
        active: data && parseInt(data.ACTIVE) === 1 ? 1 : 0,
        edit: mode === 'edit' ? 1 : 0,
        id: data ? data.ID : -1,
      },
      ignoreBackdropClick: true,
    });
    this.modalRef.onClose.subscribe((modalData: Apps) => {
      if (!modalData) {
        return;
      }
      if (mode === 'add') {
        this.dataSource = [...this.dataSource, { ...modalData }];
      } else if (mode === 'edit' && data) {
        const index = this.dataSource.indexOf(data);
        this.dataSource[index] = modalData;
        this.dataSource = [...this.dataSource];
      }
    });
    this.modalRef.component.OnGuardarClicked.subscribe(async () => {
      await  this.getAllApps();
    });
  }

  onDeleteClick(data: Apps): void {

    let title_ = parseInt(data.ACTIVE) === 1 ? 
    "¿Realmente desea DESACTIVAR esta APP?" : 
    "¿Realmente desea ACTIVAR esta APP?";

    let titleConfirm = parseInt(data.ACTIVE) === 1 ? 
    "Desactivado" : 
    "Activado";

    let deleteObj = {
      id: data.ID,
      table_name: 'APPS',
      action: 'DELETE',
      active_option: parseInt(data.ACTIVE) == 1 ? 0 : 1
  }

  Swal.fire({
    title: title_,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sí',
    cancelButtonText: 'Cancelar',
    allowOutsideClick: false
  }).then((result) => {
    if (result.isConfirmed) {
      Swal.fire({
        title: 'Procesando...',
        allowOutsideClick: false,
        showCancelButton: false,
        showCloseButton: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
          this.crudService.crud(deleteObj, environment.GenericCrudOperation).toPromise().then(() => {
            this.getAllApps();
            Swal.fire({
              icon: 'success',
              title: 'Registro '+titleConfirm+' correctamente',
              showConfirmButton: false,
              timer: 500
            });
          }).catch((error) => {
            // Control de error en caso de que falle la eliminación en el servidor
            Swal.fire({
              icon: 'error',
              title: 'Error al eliminar el registro',
              text: error.message,
              allowOutsideClick: false,
            });
          });
        }
      });
    }
  });
    this.loading = false;
  }
}
